import React, { useState } from "react";
import useAuth from "@/hooks/useAuth";
import { useNavigate } from "react-router";
import { useSendLogoutMutation } from "@/features/auth/authApiSlice";

// Components
import EtWebAdminTopBar from "@/components/admin/EtWebAdminTopBar";
import EtWebAdminLeftMenu from "@/components/admin/EtWebAdminLeftMenu";
import EtWebAdminContentArea from "@/components/admin/EtWebAdminContentArea";

// Menu Items
import adminWebMenuItems from "@/data/admin/adminWebMenuItems";

const EtWebAdmin = () => {

  // First Created - 29 Nov 2025
  // Author - Atul Pandey 
  // Updated - 30 Nov 2025 - changed default to "growthSparks" from "analyticsOverview"

  // 1 - Admin Access
  const { isAdmin, name } = useAuth();
  const navigate = useNavigate();

 

  // 2 - State
  const [activeMenuItem, setActiveMenuItem] = useState("growthSparks");
  const [sendLogout] = useSendLogoutMutation();

  // 3 - Logout
  const handleLogout = async () => {
    try {
      await sendLogout().unwrap();
      navigate("/login");
    } catch (err) {
      console.log("logout failed:", err);
    }
  };

  // 4 - NOW you return conditionally
  if (!isAdmin) {
    return (
      <div className="text-center text-red-600 mt-20 font-semibold">
        Access Denied. Admins Only.
      </div>
    );
  }

  return (
    <div className="bg-gray-200 min-h-screen p-2 font-poppins rounded">
        
      {/* Top Bar */}
      <EtWebAdminTopBar name={name} handleLogout={handleLogout} />

      <div className="flex mt-3">

        {/* Left Menu Panel */}
        <EtWebAdminLeftMenu 
          activeMenuItem={activeMenuItem}
          setActiveMenuItem={setActiveMenuItem}
          menuItems={adminWebMenuItems}
        />

        {/* Right Content Panel */}
        <EtWebAdminContentArea 
          activeMenuItem={activeMenuItem}
        />

      </div>

    </div>
  );
};

export default EtWebAdmin;